import { Res } from 'common/types/responses'
import { Req } from 'common/types/requests'
import { service } from 'common/service'

export const recaptchaService = service
  .enhanceEndpoints({ addTagTypes: [] })
  .injectEndpoints({
    endpoints: (builder) => ({
      verifyRecaptcha: builder.mutation<
        Res['verifyRecaptcha'],
        Req['verifyRecaptcha']
      >({
        query: (query: Req['verifyRecaptcha']) => ({
          body: query,
          method: 'POST',
          url: `auth/verify-recaptcha`,
        }),
      }),
      // END OF ENDPOINTS
    }),
  })

export async function verifyRecaptcha(
  store: any,
  data: Req['verifyRecaptcha'],
  options?: Parameters<
    typeof recaptchaService.endpoints.verifyRecaptcha.initiate
  >[1],
) {
  return store.dispatch(
    recaptchaService.endpoints.verifyRecaptcha.initiate(data, options),
  )
}
// END OF FUNCTION_EXPORTS

export const {
  useVerifyRecaptchaMutation,
  // END OF EXPORTS
} = recaptchaService

/* Usage examples:
const [verifyRecaptcha, { isLoading, data, isSuccess }] = useVerifyRecaptchaMutation() //verify hook
recaptchaService.endpoints.verifyRecaptcha.select({recaptcha_token: 'token'})(store.getState()) //access data from any function
*/
